"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateassetsexpdate = exports.listMini = exports.insuranceDelete = exports.insuranceRequest = exports.syncInsuranceRequest = exports.massCreatePatient = exports.futureRefills = exports.removeFile = exports.getUploads = exports.updateassetsdescriptions = exports.uploadFile = exports.submittomanysites = exports.submit = exports.parseColumnsHeader = exports.parse = exports.recover = exports.remove = exports.save = exports.resetwaterfall = exports.read = exports.listorders = exports.list = exports.listsimilarpatients = exports.mergepatientsrelations = exports.create = void 0;
const endpoint_1 = require("api/endpoint");
const permissions_1 = require("shared/permissions");
exports.create = endpoint_1.createEndpoint()({
    method: "post",
    path: "patient/create",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_PATIENT_CREATE
});
exports.mergepatientsrelations = endpoint_1.createEndpoint()({
    method: "post",
    path: "patient/mergepatientsrelations",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_PATIENT_CREATE
});
exports.listsimilarpatients = endpoint_1.createEndpoint()({
    method: "get",
    path: "patient/listsimilarpatients",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_PATIENT_READ
});
// C-097 Patients
exports.list = endpoint_1.createEndpoint()({
    method: "get",
    path: "patient/list",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_PATIENT_READ
});
// export const listAll = createEndpoint<
//   { siteId: number },
//   { patients: IPatient[] }
// >()({
//   permissions: PERMISSIONS.DISPENSIFY_PATIENT_READ,
//   method: "post",
//   path: "patient/list-all"
// });
exports.listorders = endpoint_1.createEndpoint()({
    method: "get",
    path: "patient/listorders",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_ORDER_READ
    // query: {
    //   count?: number;
    //   id?: number;
    //   order?: 'ASC' | 'DESC';
    //   search?: string;
    //   searchDate?: string;
    //   showCompleted?: string;
    //   siteId?: number;
    //   sort?: string;
    //   start?: number;
    // };
});
exports.read = endpoint_1.createEndpoint()({
    method: "get",
    path: "patient/read",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_PATIENT_READ,
    tokens: { id: "number.required" }
});
exports.resetwaterfall = endpoint_1.createEndpoint()({
    method: "put",
    path: "patient/resetwaterfall",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_PATIENT_UPDATE
});
exports.save = endpoint_1.createEndpoint()({
    method: "put",
    path: "patient/save",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_PATIENT_UPDATE
});
exports.remove = endpoint_1.createEndpoint()({
    method: "delete",
    path: "patient/remove",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_PATIENT_DELETE,
    tokens: { id: "number.required" }
});
exports.recover = endpoint_1.createEndpoint()({
    method: "put",
    path: "patient/recover",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_PATIENT_DELETE,
    tokens: { id: "number.required" }
});
exports.parse = endpoint_1.createEndpoint()({
    formData: true,
    method: "post",
    path: "patient/parse",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_PATIENT_CREATE
});
exports.parseColumnsHeader = endpoint_1.createEndpoint()({
    formData: true,
    method: "post",
    path: "patient/parsecolumnsheader",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_PATIENT_CREATE
});
exports.submit = endpoint_1.createEndpoint()({
    method: "post",
    path: "patient/submit",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_PATIENT_CREATE
});
exports.submittomanysites = endpoint_1.createEndpoint()({
    method: "post",
    path: "patient/submittomanysites",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_PATIENT_CREATE
});
exports.uploadFile = endpoint_1.createEndpoint()({
    formData: true,
    method: "post",
    path: "patient/uploadFile",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_PATIENT_CREATE
});
exports.updateassetsdescriptions = endpoint_1.createEndpoint()({
    method: "post",
    path: "patient/updateassetsdescriptions",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.getUploads = endpoint_1.createEndpoint()({
    method: "post",
    path: "provider/removeFile",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_PATIENT_READ,
    tokens: { id: "number.required", type: "patient" }
});
exports.removeFile = endpoint_1.createEndpoint()({
    method: "post",
    path: "patient/removeFile",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_PATIENT_DELETE,
    tokens: { id: "number.required" }
});
exports.futureRefills = endpoint_1.createEndpoint()({
    method: "post",
    path: "patient/futureRefills",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_PATIENT_DELETE
});
exports.massCreatePatient = endpoint_1.createEndpoint()({
    method: "post",
    path: "patient/massCreatePatient",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_PATIENT_CREATE
});
exports.syncInsuranceRequest = endpoint_1.createEndpoint()({
    method: "post",
    path: "patient/syncInsuranceRequest",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_PATIENT_CREATE
});
exports.insuranceRequest = endpoint_1.createEndpoint()({
    method: "post",
    path: "patient/insuranceRequest",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_PATIENT_UPDATE
});
exports.insuranceDelete = endpoint_1.createEndpoint()({
    method: "put",
    path: "patient/insuranceDelete",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_PATIENT_UPDATE
});
exports.listMini = endpoint_1.createEndpoint()({
    method: "get",
    path: "patient/listmini",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_PATIENT_UPDATE
});
exports.updateassetsexpdate = endpoint_1.createEndpoint()({
    method: "post",
    path: "patient/updateassetsexpdate",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});



//////////////////
// WEBPACK FOOTER
// ./src/api/patient/patient-client.ts
// module id = 993
// module chunks = 0 1 2